import { IRequestCommand } from "app/services/authentication/connection/iRequestCommand";
import { ErrorDetails } from "app/services/authentication/connection/interfaces/apiInterfaces";
import { CommandRequestType } from "app/services/authentication/connection/commandRequestType";
import { ICommandParameters } from "app/services/authentication/connection/iCommandParameters";
import { ServiceResponseDto } from "app/services/interfaces/services-types.interface";

export class GetServicesTypesCommand extends IRequestCommand<
  Array<ServiceResponseDto>,
  ErrorDetails,
  IGetServicesTypesCommandParameters
> {
  override _commandType: CommandRequestType = CommandRequestType.GET;
  override _commandUrl = 'carriers/{carrierId}/serviceTypes';

  public override setParameters(parameters: IGetServicesTypesCommandParameters) {
    this.urlSections.push('carriers');
    this.urlSections.push(`${parameters.carrierId}`);
    this.urlSections.push('serviceTypes');
    if(parameters.passengerId){
      this.paramsSections.push(`passengerId=${parameters.passengerId}`)
    }
    if(parameters.serviceType){
      this.paramsSections.push(`serviceType=${parameters.serviceType}`)
    }
    if(parameters.contractorAccountId){
      this.paramsSections.push(`contractorAccountId=${parameters.contractorAccountId}`)
    } else if (parameters.contractorAccountId == '') {
      this.paramsSections.push(`contractorAccountId=`)
    }
    if(parameters.active != null){
      this.paramsSections.push(`active=${parameters.active?'true':'false'}`)
    }
    this.composeUrl();
  }
}

export interface IGetServicesTypesCommandParameters extends ICommandParameters {
  carrierId: string;
  contractorAccountId?: number | string;
  passengerId?: number;
  serviceType?: string;
  active?: boolean;
}
